document.addEventListener('DOMContentLoaded', () => {
  const container_filter_list = document.querySelector('.collection-filter-list');

  if (container_filter_list) {
    let isDragging = false;
    let startPosition = 0;
    let startScrollLeft = 0;
  
    const handleMouseDown = (e) => {
      isDragging = true;
      startPosition = e.clientX;
      startScrollLeft = container.scrollLeft;
      e.preventDefault(); // Prevent text selection
    };
  
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startPosition;
      container_filter_list.scrollLeft = startScrollLeft - deltaX;
    };
  
    const stopDragging = () => {
      isDragging = false;
    };
  
    container_filter_list.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', stopDragging);
    container_filter_list.addEventListener('mouseleave', stopDragging);
  }
});